import React, { useContext, useState } from "react";
import { max } from "simple-utils";
import { AccountContext } from "../account/AccountContext";
import { Modal } from "../components/Modal";
import { useIsGuest } from "../login/AuthContext";
import { Account } from "../models/Account";
import { TagContext, useFranchiseTags } from "./tag-context";
import { ColorTagDisplay, TagDisplay } from "./tags";
import { addTag, deleteTag, replaceTags, Tag, TagColors, updateTag } from "./tags-api";


export function TagEditor({tag, onCancel, onSave, onDelete}:{tag:Tag, onCancel:()=>void, onSave:(tag:Tag) => void, onDelete:(id:number) => void}){
    const [t, setTag] = useState({...tag});
    const [error, setError] = useState<string>(null)
    const [removeMode, setRemoveMode] = useState(false);

    function doSave(){
        if(t.name == ''){
            return setError('Escolha um título.')
        }
        onSave(t);
    }

    return <>
        <input className="form-control" value={t.name} placeholder="Título" onChange={(e)=> setTag({...t, name: e.target.value}) } />
        <div className="d-flex flex-wrap my-3">
            {TagColors.map(e => {
                return <button key={e}
                    onClick={() => setTag({...t, color: e}) }
                 className={`btn btn-${e} me-2 mb-2`} style={{width:"15px", height:"26px", outline: e == t.color ?  "solid 2px var(--bs-primary)" : "none", outlineOffset:"2px"}}></button>
            })}
        </div>
        {error && <div className="alert alert-danger"><b>Erro:</b> {error}</div> }
        
        {!removeMode && <div className="d-flex flex-wrap justify-content-end">
            {tag.id != 0 && <div className="flex-grow-1 mb-2 mb-sm-0"><button className="btn btn-danger" onClick={() => setRemoveMode(true)}><i className="fa fa-trash"></i> Remover</button></div>}
            <div>
                <button className="btn btn-info me-2" onClick={onCancel}>Cancelar</button>
                <button className="btn btn-primary" onClick={doSave}>{tag.id == 0 ? 'Criar' : 'Salvar'}</button>
            </div>
        </div>}

        {removeMode && <div className="d-flex flex-wrap">
            <div className="flex-grow-1 mb-2 mb-sm-0">Deseja realmente remover a tag?</div>
            <div>
                <button className="btn btn-info me-2" onClick={() => setRemoveMode(false)}>Cancelar</button>
                <button className="btn btn-danger" onClick={() => onDelete(tag.id)}><i className="fa fa-trash"></i> Remover</button>
            </div>
        </div>}
    </>
}

function TagPickerEntry({isSelected, tag, onSelect, onEdit}:{isSelected: boolean, tag:Tag, onSelect:(id:number, on:boolean) => void, onEdit: (id:number) => void}){
    return <div className="d-flex align-items-center mb-2">
        <div><input className="form-check-input" type="checkbox" checked={isSelected} onChange={(e) => onSelect(tag.id, e.target.checked)} /></div>
        <div className="flex-grow-1 mx-2">
            <span className={`badge bg-${tag.color} py-2 w-100`} onClick={() => onSelect(tag.id, !isSelected)}>{tag.name}</span>
        </div>
        <div>
            <button className="btn btn-primary" onClick={() => onEdit(tag.id)}><i className="fa fa-pencil"></i></button>
        </div>
    </div>
}

export function TagPicker({selected, setSelected, franchise}:{selected:number[], franchise:number, setSelected:(tags:number[])=>void}){
    const tags = useFranchiseTags(franchise);
    const {dispatch} = useContext(TagContext);
    const [editTag, setEditTag] = useState<Tag>(null);


    function updateSelect(id: number, on:boolean){
        setSelected(on ? [...selected, id] : selected.filter(i => i != id))
    }

    function onEditTag(t:number){
        setEditTag(tags.find(i => i.id == t));
    }

    async function onSave(tag:Tag){
        setEditTag(null)
        if(tag.id == 0){
            tag = await addTag(tag);
            dispatch({type: "setFranchiseTags", franchise, tags: [...tags, tag]});   
            setSelected([...selected, tag.id]) 
            return;
        }
        updateTag(tag);
        dispatch({type: "setFranchiseTags", franchise, tags: tags.map(i => i.id == tag.id ? tag : i)});
    }

    function onDelete(id:number){
       setEditTag(null)
       dispatch({type: "setFranchiseTags", franchise, tags: tags.filter(a => a.id != id)});
       deleteTag(id);
    }


    if(editTag)
        return <TagEditor tag={editTag} onCancel={() => onEditTag(-1)}  onSave={onSave} onDelete={onDelete}  />

    return <div style={{maxWidth: '500px'}}>
        <div className="mb-3 text-center"><button className="btn btn-primary" onClick={()=>setEditTag({id:0, name: '', color: 'primary', franchise})}>Adicionar Tag</button></div>
        {tags.map(t => <TagPickerEntry key={t.id} isSelected={selected.includes(t.id)} tag={t} onEdit={onEditTag} onSelect={updateSelect}/>)}
    </div>
}

export function TagAccountModal({account}:{account:Account}){
    const [tags, setTags] = useState(account.tags || []);
    const {dispatch} = useContext(AccountContext)

    function updateSelected(tags:number[]){
        setTags(tags);
        dispatch({type:"updateTags", payload: {account: account.id, tags}})
        replaceTags(account.id, tags);
    }

    return <TagPicker franchise={account.franchise} selected={tags} setSelected={updateSelected} />
}

export function TagAccountEditorButton({account}:{account:Account}){
    const {state, dispatch} = useContext(TagContext);
    const isGuest = useIsGuest();
    if(isGuest) return null;

    return <>
        <button className="btn btn-primary" onClick={() => dispatch({type:"setEditingAccount", account})}><i className="fa fa-tags"></i> Editar Tags</button>
            {state.account && <Modal title="Editar Tags" onHide={() => dispatch({type:"setEditingAccount", account: null})}>
                <TagAccountModal account={account} />
            </Modal>}
    </>


}